import isPlainObject from 'lodash/isPlainObject'
import isArray from 'lodash/isArray'

export const formatResponse = (response, fallback = '') => {
  /*
   * Will return a string if response is of type string.
   *
   * Will break down an object/json response into a list of strings.
   *
   * Will return fallback value if not a plain object or a string.
   */
  if (typeof response === 'string') {
    return response
  }

  if (!isPlainObject(response)) {
    return fallback
  }

  return Object.keys(response).reduce((acc, c) => {
    const value = response[c]

    if (Array.isArray(value)) {
      return [...acc, ...value]
    }

    return [...acc, value]
  }, [])
}

export const formatErrorMessage = error =>
  isArray(error.response?.data?.message)
    ? error.response.data.message.join('. ')
    : (error.response?.data?.message ?? '')

export const getFormValidationError = (error, fallback = 'Something went wrong') =>
  (error?.errors?.[0] ?? formatErrorMessage(error)) || fallback
